import { heroEquipment } from "../HeroEquipment";

export const orki = {
  heroes: {
    "Herszt orków": {
      id: 0,
      startingEquipment: ["Sztylet", "Rembak", "Rembak", "Broń wielka"],
      cost: 85,
      number: 1,
      equipmentList: heroEquipment["Orkowie & Gobliny"].Bohaterowie,
      type: "Bohater",
      stats: {
        "Początkowa": [4,5,3,4,4,2,2,1,8],
        "Maksymalna": [5,8,4,5,5,3,5,4,9]
      },
      rules: ["Dowódca", "Zbrojny po zemby", "Do Łooomotu!", "Za mną!"],
      exp: 20,
      skills: [0, 3, 4, 5],
    },
    "Szaman orków": {
      id: 1,
      startingEquipment: ["Sztylet", "Kostur"],
      cost: 45,
      number: 1,
      equipmentList: heroEquipment["Orkowie & Gobliny"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 3, 3, 3, 4, 1, 3, 1, 7],
        Maksymalna: [5, 7, 5, 4, 5, 3, 5, 4, 8],
      },
      rules: ["Mag (Magia Dużego Łooomotu!)"],
      exp: 10,
      skills: [0, 3, 4, 5],
    },
    "Burszuj orków": {
      id: 2,
      startingEquipment: [],
      cost: 40,
      number: 2,
      equipmentList: heroEquipment["Orkowie & Gobliny"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 4, 3, 3, 4, 1, 3, 1, 7],
        Maksymalna: [5, 7, 5, 4, 5, 3, 5, 4, 8],
      },
      rules: ["Zbrojny po zemby"],
      exp: 8,
      skills: [0, 1, 3, 4, 5],
    },
    Ork: {
      id: 3,
      startingEquipment: ["Sztylet", "Rembak"],
      cost: 25,
      number: 15,
      equipmentList: heroEquipment["Orkowie & Gobliny"].Ork,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 3, 3, 3, 4, 1, 2, 1, 7],
        Maksymalna: [5, 7, 5, 4, 5, 3, 5, 4, 8],
      },
      rules: ["Animozja", "Chorążowie & sygnaliści"],
    },
    Goblin: {
      id: 4,
      startingEquipment: ["Sztylet", "Buława/Maczuga/Młot bojowy"],
      cost: 15,
      number: 15,
      equipmentList: heroEquipment["Orkowie & Gobliny"].Goblin,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 2, 3, 3, 3, 1, 3, 1, 5],
        Maksymalna: [5, 5, 6, 3, 4, 3, 6, 4, 7],
      },
      rules: [
        "Animozja",
        "Drużyna obsługi",
        "Dziwnie cuchnom",
        "Rozmiar rzondzi",
        "Za cienki w uszach",
      ],
    },
    Snotling: {
      id: 6,
      startingEquipment: ["Broń improwizowana", "Wybuchowe zarodniki"],
      cost: 10,
      number: 15,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: [4, 2, 0, 2, 2, 1, 3, 1, 4],
        Maksymalna: [4, 2, 0, 2, 2, 1, 3, 1, 4],
      },
      rules: [
        "Mięso armatnie",
        "Nieświadomy",
        "Rozmiar rzondzi",
        "Sfora",
        "Śmigły",
        "Wybuchowe zarodniki",
      ],
    },
    "Gobliński fanatyk": {
      id: 7,
      startingEquipment: ["Kula na łańcuchu"],
      cost: 50,
      number: 1,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: ["2K6", "-", "-", 5, 3, 1, 3, "K3", 10],
        Maksymalna: ["2K6", "-", "-", 5, 3, 1, 3, "K3", 10],
      },
      rules: ["Dziwnie cuchnom", "Gobliński fanatyk"],
    },
    Squig: {
      id: 8,
      startingEquipment: ["Broń naturalna"],
      cost: 15,
      number: 15,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: ["2K6", 4, 0, 5, 3, 1, 3, 2, 3],
        Maksymalna: ["2K6", 4, 0, 5, 3, 1, 3, 2, 3],
      },
      rules: [
        "Dzikie squigi",
        "Niezłomny",
        "No to hooop!",
        "Rozmiar rzondzi",
        "Zwierzę",
      ],
    },
    "Ork na dziku": {
      id: 9,
      startingEquipment: ["Sztylet", "Rembak", "Dzik", "Siodło & uprząż"],
      cost: 80,
      number: 3,
      equipmentList: heroEquipment["Orkowie & Gobliny"].Ork,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 3, 3, 3, 4, 1, 2, 1, 7],
        Maksymalna: [5, 7, 5, 4, 5, 3, 5, 4, 8],
        Dzik: [7, 3, 0, 3, 4, 1, 3, 1, 3],
      },
      rules: ["Animozja", "Duży cel (wierzchem)", "Kawalerzysta"],
    },
    Troll: {
      id: 10,
      startingEquipment: ["Broń naturalna"],
      cost: 200,
      number: 1,
      equipmentList: {
        "Troll Górski": [50, 3, "Choice"],
        "Troll Rzeczny": [50, 3, "Choice"],
      },
      type: "Stronnik",
      stats: {
        Początkowa: [6, 3, 1, 5, 4, 3, 1, 3, 4],
        Maksymalna: [6, 3, 1, 5, 4, 3, 1, 3, 4],
      },
      rules: ["Bycza szarża","Duży cel","Gatunki trolli","Głód trzewi","Głupota","Nieświadomy","Niezłomny","Przepastne trzewia","Regeneracja","Strach","Wielkolud","Żrąca plwocina"],
    },
    Rydwan: {
      id: 11,
      startingEquipment: [],
      cost: 125,
      number: 1,
      equipmentList: {},
      type: "Machina",
      stats: {
        Rydwan: ["-", "-", "-", 5, 5, 8, "-", "-", "-"],
        Dzik: [7, 3, 0, 3, "-", "-", 3, 1, 3],
        "Dzik ": [7, 3, 0, 3, "-", "-", 3, 1, 3],
      },
      rules: ["Duży cel", "Machina wojenna", "Rydwan", "Szarża dzików"],
    },
  },
  limit: 500,
  minModels: 3,
  maxModels: 15,
  name: "Orkowie & Gobliny",
  nature: "Zła",
  armyRules: ["Podatek", "Rozrzutność"],
  mercenaries: [
    "Czarny Ork",
    "Grzybowar",
    "Mekaniak",
    "Miotacz ołowiu",
    "Ochroniarz",
  ],
};
